import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import type { IServiceLogItem, IServiceLogItemDto } from "./IServiceLogItem";

export class ServiceLogItem implements IServiceLogItem
{

    vehicleId: string;
    title: string;
    utcDateCreated: Dayjs;
    locationName?: string;
    locationBusinessId?: string;
    purchaseAmount?: number;
    cashbackAmount?: number;

    constructor( model: IServiceLogItemDto )
    {
        this.vehicleId = model.vehicleId;
        this.title = model.title;
        this.utcDateCreated = dayjs( model.utcDateCreated );
        this.locationName = model.locationName;
        this.locationBusinessId = model.locationBusinessId;
        this.purchaseAmount = model.purchaseAmount;
        this.cashbackAmount = model.cashbackAmount;
    }

}
